__turbopack_context__.v({
  "actions": "search-bar-module__FABvFW__actions",
  "chevronDownIcon": "search-bar-module__FABvFW__chevronDownIcon",
  "close": "search-bar-module__FABvFW__close",
  "close1": "search-bar-module__FABvFW__close1",
  "closeIcon": "search-bar-module__FABvFW__closeIcon",
  "container": "search-bar-module__FABvFW__container",
  "mobileContainer": "search-bar-module__FABvFW__mobileContainer",
  "mobileOverlay": "search-bar-module__FABvFW__mobileOverlay",
  "navbar": "search-bar-module__FABvFW__navbar",
  "search": "search-bar-module__FABvFW__search",
  "searchBar": "search-bar-module__FABvFW__searchBar",
  "searchBarVisible": "search-bar-module__FABvFW__searchBarVisible",
  "searchButton": "search-bar-module__FABvFW__searchButton",
  "searchButtonMobile": "search-bar-module__FABvFW__searchButtonMobile",
  "searchDynacastBy": "search-bar-module__FABvFW__searchDynacastBy",
  "searchIcon": "search-bar-module__FABvFW__searchIcon",
  "searchInput": "search-bar-module__FABvFW__searchInput",
  "searchInputBar": "search-bar-module__FABvFW__searchInputBar",
  "searchInputBarMobile": "search-bar-module__FABvFW__searchInputBarMobile",
  "searchInputMobile": "search-bar-module__FABvFW__searchInputMobile",
  "searchInputPlaceholder": "search-bar-module__FABvFW__searchInputPlaceholder",
  "searchOverlayVisible": "search-bar-module__FABvFW__searchOverlayVisible",
  "searchTitleMobile": "search-bar-module__FABvFW__searchTitleMobile",
  "searchWrapper": "search-bar-module__FABvFW__searchWrapper",
  "slideDown": "search-bar-module__FABvFW__slideDown",
});
